module.exports = __webpack_public_path__ + "img/share.5ef8f6ee.svg";